import Vue from 'vue'
import Router from 'vue-router'
//模板页面
import Layout from '@/components/common/layout'

//控制台
import web from './module/web'
import home from './module/home'
import zhongzhuanbuhuo from './module/zhongzhuanbuhuo'
import yikuhuanbiao from './module/yikuhuanbiao'
import tuihuozhijian from './module/tuihuozhijian'
import prep from './module/prep'
import client_mgr from './module/client_mgr'
import bill from './module/bill'
import download from './module/download'
import zhongzhuanfahuo from './module/zhongzhuanfahuo'



Vue.use(Router)
export default new Router({
  routes: [
    ...web,
    {
      path: '',
      component: Layout,
      meta: {
        title: '控制台'
      },
      redirect: '/Home',
      children: [
        ...home,
        ...zhongzhuanbuhuo,
        ...yikuhuanbiao,
        ...tuihuozhijian,
        ...prep,
        ...client_mgr,
        ...bill,
        ...download,
        ...zhongzhuanfahuo
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js